/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Divider from "@mui/material/Divider";
import Select from '@mui/material/Select';
import { Card, Checkbox, Icon, Input } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import { FormHelperText } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { getInventoryRawMaterials, getInventoryFinishedGoods, createRecipe, updateRecipe, getRecipeIngredients, getUOM } from "network/service";
import { useNotification } from "context/notification.context";
import { addPricingTemplate } from "network/service";




export default function AddEditTemplatePopup(props) {
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);
    const [newField, setNewField] = useState({ name: "", code: "", product: "", quantity: "0", description: "" });
    const [calcs, setCals] = useState([]);
    const [configs, setConfig] = useState([]);
    const [qtym, setQtym] = useState(0);
    const [rateFlag, setFlag] = useState(false);
    const theme = useTheme();
    const [currentPageIndex, setCurrentPageIndex] = useState(0);


    const addItem = () => {
        if ((calcs.length == 0) || (calcs[calcs.length - 1] < parseFloat(qtym))) {
            let temp = parseFloat(qtym);
            setCals([...calcs, temp]);
            setConfig([...configs, rateFlag ? true : false]);
            setQtym("");
        }
    }

    const deleteItem = (index) => {
        console.log("Deleting", index);
        const temp = [...calcs];
        temp.splice(index, 1);
        const temp2 = [...configs];
        temp2.splice(index, 1);
        setCals(temp);
        setConfig(temp2);
    }


    const validate = () => {
        if (newField.name.trim() === "") {
            isValid = false;
        }
        if (newField.code.trim() === "") {
            isValid = false;
        }
        return true;
    };

    const Create = async () => {

        if (validate()) {
            try {
                setLoading(true);
                await addPricingTemplate({
                    template_name: newField.name,
                    template_code: newField.code,
                    calculation: calcs,
                    config: configs
                });
                props.handlesuccess();
                showNotification("success", "Success", "Pricing Template Created Successfully");
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
    };

    const formCalcsRows = () => {
        let rows = [];
        for (let i in calcs) {
            let row = {
                to: calcs[i],
                from: i == 0 ? 0 : (i == calcs.length) ? "Above" : calcs[i - 1],
                uom: "KG",
                per: <Checkbox defaultChecked={configs[i]} disabled />,
                action: <MDButton variant="outlined" color="error" iconOnly onClick={() => { deleteItem(i) }}><Icon>delete</Icon></MDButton>
            };
            rows.push(row);
        }
        return rows;
    }

    return (

        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >

            <Card sx={{}}>
                <MDBox  >
                    <DialogTitle>Add Pricing Template</DialogTitle>
                </MDBox>
                <DialogContent sx={{ minWidth: 500 }}>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6} xl={8}>
                                    <MDInput
                                        label="Template Name"
                                        value={newField.name}
                                        fullWidth
                                        onChange={(e) => {
                                            setNewField({
                                                ...newField,
                                                name: e.target.value.toUpperCase()
                                            });
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} md={6} xl={4}>
                                    <MDInput
                                        fullWidth
                                        label="Template Code"
                                        value={newField.code}

                                        onChange={(e) => {
                                            setNewField({
                                                ...newField,
                                                code: e.target.value.toUpperCase()
                                            });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid item>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12} xl={12}>
                                    <Grid container sx={{ alignItems: 'center' }}>
                                        <MDInput
                                            sx={{ flexGrow: 1, marginRight: 1 }}
                                            label="Quantity"
                                            value={qtym}
                                            type="number"
                                            onChange={(e) => {
                                                setQtym(e.target.value);
                                            }}
                                        />
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox defaultChecked
                                                onChange={(e) => {
                                                    console.log("checkbox checking", e.target.checked);
                                                    setFlag(e.target.checked);
                                                }} />} label="Rate per Kg" />
                                        </FormGroup>

                                        <MDButton variant="outlined" color="success"
                                            iconOnly
                                            disabled={loading}
                                            sx={{ marginLeft: 1 }}
                                            onClick={() => { addItem() }}>
                                            <Icon>add</Icon>
                                        </MDButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Card sx={{ backgroundColor: theme.palette.primary.main, opacity: 0.95 }} >
                                <DataTable
                                    table={{
                                        columns: [
                                            { Header: "From", accessor: "from", align: "left" },
                                            { Header: "To", accessor: "to", align: "center" },
                                            { Header: "Unit", accessor: "uom", align: "center" },
                                            { Header: "per Kg", accessor: "per", align: "center" },
                                            { Header: "Action", accessor: "action", align: "center" },
                                        ],
                                        rows: formCalcsRows(calcs)
                                    }}
                                    showTotalEntries={false}
                                    isSorted={false}
                                    noEndBorder
                                    entriesPerPage={false}
                                    currentPageIndex={currentPageIndex}
                                    setCurrentPageIndex={setCurrentPageIndex}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>

                    <MDButton variant="gradient" color="error" onClick={props.handleclose}
                        disabled={loading}>
                        <Icon>close</Icon>&nbsp;
                        Cancel
                    </MDButton>
                    <MDButton variant="gradient" color="success"
                        disabled={loading}
                        onClick={() => { Create() }}>
                        <Icon>save</Icon>&nbsp;
                        Save
                    </MDButton>
                </DialogActions>
            </Card>
        </Dialog>


    )
};
